module.exports = __webpack_public_path__ + "img/stars.d2ee2fdd.svg";